import { render } from "./Err403View.vue?vue&type=template&id=623a2dcf"
import script from "./Err403View.vue?vue&type=script&lang=js"
export * from "./Err403View.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__